var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDownProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrowDownProfile",
    transform: "translate(21.000000, 21.000000) rotate(-90.000000) translate(-21.000000, -21.000000) translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#646464",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2470038,20.0031707 L23.0841868,14.3914634 C23.2449143,14.2373171 23.3333333,14.0312195 23.3333333,13.8114634 C23.3333333,13.5915853 23.2449143,13.3856098 23.0841868,13.2312195 L22.5727008,12.7397561 C22.412227,12.5851219 22.1977124,12.5 21.9691167,12.5 C21.7405209,12.5 21.52626,12.5851219 21.3656595,12.7397561 L14.4155628,19.4209756 C14.254328,19.5758537 14.1660357,19.7828049 14.1666633,20.0028049 C14.1660357,20.2237805 14.2542012,20.4304878 14.4155628,20.5854878 L21.3591898,27.2602439 C21.5197903,27.4148781 21.7340513,27.5 21.9627738,27.5 C22.1913696,27.5 22.4056305,27.4148781 22.5663579,27.2602439 L23.0777172,26.7687805 C23.4104622,26.4489024 23.4104622,25.9281707 23.0777172,25.6084147 L17.2470038,20.0031707 Z",
    id: "path-1",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownProfile);
export default __webpack_public_path__ + "static/media/arrowDownProfile.d2f3bd289ac029204ba3663bdd4e4069.svg";
export { ForwardRef as ReactComponent };